var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[_c('h2',{staticClass:"text-italic",domProps:{"innerHTML":_vm._s("AÇ<b>AI</b>")}}),_c('span',{staticClass:"material-icons",domProps:{"innerHTML":_vm._s("restaurant_menu")}})])}
var staticRenderFns = []

export { render, staticRenderFns }